import { User } from 'lib-shared-types-api';
import { PureComponent } from 'react';

import { MessageStatus } from '../messageStatus';

import transferTypes from './utils/transferTypes';

type StatusTransferAnsweredProps = {
  /** The message object */
  message: any;
};

export default class StatusTransferAnswered extends PureComponent<StatusTransferAnsweredProps> {
  constructor(props: StatusTransferAnsweredProps) {
    super(props);
  }

  getRecipientName(author: User | null) {
    if (!author) return null;
    const { name, phone_number, email } = author;

    if (name && name.trim().length) {
      return name;
    }
    return phone_number || email || null;
  }

  generateStatusText(recipient: string | null, type: string) {
    return `${transferTypes.getTypeString(type)} answered${
      recipient ? ` by ${recipient}` : ''
    }`;
  }

  render() {
    const { message, ...otherProps } = this.props;

    const recipient = this.getRecipientName(message.author);
    const statusText = this.generateStatusText(
      recipient,
      message.transfer_type,
    );

    return <MessageStatus {...(otherProps as any)} text={statusText} />;
  }
}
